const addHttps = url => {
  if (/^https?:\/\//.test(url) === true) {
    return url;
  } else {
    return 'https://' + url;
  }
};

export default addHttps;
